import styles from './LastWreckScreen.module.css';
import { Icon } from './icons';
import type { RunResultState } from './types';

const OUTCOME_COPY = {
  'contract-fulfilled': ['CONTRACT FULFILLED', 'Navigation core secured'],
  'precision-salvage': ['PRECISION SALVAGE', 'Core and data prism recovered intact'],
  'barely-escaped': ['BARELY ESCAPED', 'Core locked during structural failure'],
  failed: ['CONTRACT FAILED', 'The navigation core was left behind'],
} as const;

export function RunResults({
  result,
  onRestart,
  onContinue,
}: {
  result: RunResultState;
  onRestart: () => void;
  onContinue: () => void;
}) {
  const copy = OUTCOME_COPY[result.outcome];
  const successful = result.outcome !== 'failed';
  const minutes = Math.floor(result.elapsedSeconds / 60);
  const seconds = result.elapsedSeconds % 60;

  return (
    <div
      aria-labelledby="results-title"
      aria-modal="true"
      className={styles.modalScrim}
      role="dialog"
    >
      <section className={styles.resultsPanel} data-success={successful}>
        <div className={styles.resultSignal}>
          <Icon name={successful ? 'target' : 'warning'} />
        </div>
        <span className={styles.eyebrow}>{copy[0]}</span>
        <h2 id="results-title">{copy[1]}</h2>
        {result.isBestScore && <span className={styles.bestMark}>NEW BEST RECOVERY</span>}

        <div className={styles.scoreBlock}>
          <span>FINAL SCORE</span>
          <strong>{result.score.toLocaleString()}</strong>
        </div>
        <dl className={styles.scoreBreakdown}>
          <div>
            <dt>Banked salvage</dt>
            <dd>{result.bankedValue.toLocaleString()}</dd>
          </div>
          <div>
            <dt>Time bonus</dt>
            <dd>+{result.timeBonus.toLocaleString()}</dd>
          </div>
          <div>
            <dt>Condition bonus</dt>
            <dd>+{result.conditionBonus.toLocaleString()}</dd>
          </div>
          <div>
            <dt>Core condition</dt>
            <dd>{Math.round(result.coreCondition)}%</dd>
          </div>
          <div>
            <dt>Operation time</dt>
            <dd>
              {minutes}:{seconds.toString().padStart(2, '0')}
            </dd>
          </div>
        </dl>
        <div className={styles.resultsActions}>
          <button className={styles.quietButton} onClick={onRestart}>
            Run again
          </button>
          <button className={styles.primaryButton} onClick={onContinue}>
            Continue
          </button>
        </div>
      </section>
    </div>
  );
}
